export {
  useListExtOpsIntegrations,
  listExtOpsIntegrationsQueryKey,
} from '@omnea-app/fe-organisation-integrations/useListExtOpsIntegrations'
